import React from 'react';
import { Switch, Route } from 'react-router';
import { OverviewLocation } from './locations/OverviewLocation';
import { DevicesLocation } from '../devices/locations/DevicesLocation';
import { OverviewSite } from './locations/sites/OverviewSite';
import { OverviewOrganization } from './organization/OverviewOrganization';
import { AppRoutes } from '../../routes';
import { DataProviderCache } from '../../data/DataProviders/DataProviderCache';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { ContentContainer } from '../../components/ContentContainer';
import { LocationsDropdownToolbar } from '../../components/LocationsDropdownToolbar/LocationsDropdownToolbar';
import { RecordDataIndicators } from '../../components/RecordDataIndicators';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

export const Overview: React.FC = () => {
    const selectedOrganizationData = useSelectedOrganizationData();
    const { t } = useLanguageLocale();

    if (!isRecordFound(selectedOrganizationData)) {
        return (
            <>
                <DataProviderCache for="Organization - Not Found Organization Locations Dropdown Toolbnar">
                    <LocationsDropdownToolbar title={t('DASHBOARD.OVERVIEW_TITLE')} />
                </DataProviderCache>

                <ContentContainer>
                    <RecordDataIndicators
                        recordData={selectedOrganizationData}
                        errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                        notFoundIcon="Business"
                        notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
                    />
                </ContentContainer>
            </>
        );
    }

    return (
        <DataProviderCache for="Organization Overview">

            <Switch>
                <Route exact path={AppRoutes.OverviewOrganization} component={OverviewOrganization} />
                <Route path={AppRoutes.OverviewLocation}>
                    <Switch>
                        <Route exact path={AppRoutes.OverviewLocation}>
                            <DataProviderCache for="Single Location - Overview">
                                <OverviewLocation />
                            </DataProviderCache>
                        </Route>
                        <Route exact path={AppRoutes.OverviewLocationDevices}>
                            <DataProviderCache for="Single Location - Devices">
                                <DevicesLocation />
                            </DataProviderCache>
                        </Route>
                        <Route path={AppRoutes.OverviewSite}>
                            <DataProviderCache for="Single Location - Site">
                                <OverviewSite />
                            </DataProviderCache>
                        </Route>
                    </Switch>
                </Route>
            </Switch>
        </DataProviderCache>
    );
}